import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=b27110fc&scoped=true"
import script from "./GenericList.vue?vue&type=script&lang=js"
export * from "./GenericList.vue?vue&type=script&lang=js"
import style0 from "./GenericList.vue?vue&type=style&index=0&id=b27110fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27110fc",
  null
  
)

export default component.exports